// const ImageUrl = "https://sportingbharat.com/SV/dev/backend/storage/app/public/data/";
const ImageUrl = "https://sah.sportzvillage.com/dev/backend/storage/app/public/data/";

export default ImageUrl; 